import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/** Optional override for the primary nav bar breadcrumb (set from `PageLayoutComponent`). */
export interface PageNavHeadingOverride {
  /** Bold segment (e.g. product / area). Omit or empty to show only `page` in bold. */
  section: string | null;
  /** Muted segment after `/` when `section` is set; otherwise shown alone in bold. */
  page: string;
}

@Injectable({ providedIn: 'root' })
export class PageNavHeadingStateService {
  private readonly overrideSubject = new BehaviorSubject<PageNavHeadingOverride | null>(null);

  /** Emits the active page heading override, or `null` when no page has published one. */
  readonly override$ = this.overrideSubject.asObservable();

  setOverride(heading: PageNavHeadingOverride | null): void {
    this.overrideSubject.next(heading);
  }
}
